export default __webpack_public_path__ + "static/media/Heaven's Torment.f5fabba3.jpg";